import { votePostMessage } from "actions/bj.postmessage";
import Axios from "axios";
import classNames from "classnames";
import TitleTextArea from "components/forms/TitleTextArea";
import SelectBox from "components/SelectBox";
import { TYPE_BATTLE, TYPE_BATTLE_DRAW, TYPE_DEFAULT } from "constant/config";
import { allowLanguage } from "helpers";
import i18next from 'i18next';
import momentJalaali, { Moment } from "moment-jalaali";
import "moment/locale/es-us";
import "moment/locale/ja";
import "moment/locale/ko";
import "moment/locale/th";
import "moment/locale/vi";
import "moment/locale/zh-cn";
import "moment/locale/zh-tw";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import DatePicker from "react-datepicker2";
import { isMobile } from "react-device-detect";
import { Controller, FormContext, useForm } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import ReactResizeDetector from "react-resize-detector";
import { useHistory, useParams } from "react-router-dom";
import Answers from "./Answers";

const lang = allowLanguage();

const EDIT = "edit";
interface ISortItem {
	[key: number]: string;
}

interface IAnswer {
	answer: string;
	image: string | null;
	id: number;
	index: number;
}
type Inputs = {
	type: string;
	question: string;
	answerId: ISortItem[];
	answer: ISortItem[];
	image: ISortItem[];
	index: ISortItem[];
	answers: IAnswer[];
	date: Moment;
	hour: number;
	minute: number;
	datetime: string;
	end_at: string;
	_method: string;
};
/**
 * pluck함수
 * @param array
 * @param key
 */
const pluckWithId = (array: any[], key: string) => {
	var val: any = [];
	array.forEach((obj) => {
		var k = obj["id"];
		return (val[k] = obj[key]);
	});
	return val;
};
const pluckId = (array: any[], key: string) => {
	var val: any = [];
	array.forEach((obj) => {
		return val.push(obj["id"]);
	});
	return val;
};

/**
 * INPUT datetime Format
 */
const momentToInputString = (date: Moment): string => {
	return date.format("YYYY-MM-DDTHH:mm:00");
};

const inputStringToMoment = (date: string): Moment => {
	return momentJalaali(date, "YYYY-MM-DDTHH:mm:ss");
};

interface IParams{
	id: string;
	method: string;
}

export default function Create() {
	const { t } = useTranslation();
	const history = useHistory();
	const { id, method } = useParams<IParams>();
	const [isEnd, setEnd] = useState(false);
	const [isDraw, setDraw] = useState(false)
	const datetimeRef = useRef<HTMLInputElement | null>(null);
	const dateRef = useRef<DatePicker | null>(null);
	const drawId = useRef<number>(0);
	const formContextValues = useForm<Inputs>({
		defaultValues: {
			type: TYPE_DEFAULT,
			date: momentJalaali(),
			datetime: momentToInputString(momentJalaali().add(1, "days")),
			hour: 0,
			minute: 0,
		},
	});
	const { register, handleSubmit, watch, control, setValue } = formContextValues;
	/**
	 * 항목(초기2개)
	 */
	const [answerIds, setAnswerIds] = useState<number[]>([Math.random(), Math.random()]);
	const type = watch("type");
	const datetime = watch("datetime");

	/**
	 * 무승무 답변 제거
	 */
	const removeDrawAnswer = useCallback(() => {
			setAnswerIds((prev)=>{
				const newIds= prev.filter((item)=>item !== drawId.current)
				return newIds;				
			});
		},[])

	/**
	 * 투표타입 변경
	 */
	useEffect(() => {
		if (type === TYPE_BATTLE || type=== TYPE_BATTLE_DRAW) {
			setValue("multiple", false);
		}else{
			removeDrawAnswer();
			setDraw(false);
		}
	}, [removeDrawAnswer, setValue, type]);

	useEffect(() => {
		if (id) {
			Axios({
				url: `//bjapi.afreecatv.com/api/vote/${id}/edit`,
				withCredentials: true,
			}).then(
				(response) => {
					const data = response.data;
					const endAt = momentJalaali(data.end_at);
					/**
					 * Answer Component에 갯수를 늘려주고 값을 셋팅함
					 */
					const ids = pluckId(data.answers, "id");
					const answers = pluckWithId(data.answers, "answer");
					const images = pluckWithId(data.answers, "image");
					console.log('answers',answers)
					const filteredImages = images.filter((x : any) => x !== null);
					const type = String(data.type);
					setAnswerIds(ids);
					setValue("type", type);
					setValue("question", data.question);
					setValue("answerId", ids);
					setValue("answer", answers);
					setValue("image", images);
					setValue("date", endAt);
					setValue("hour", endAt.hour());
					setValue("minute", Math.round(endAt.minute() / 5) * 5);
					setValue("multiple", data.multiple);
					setValue("preview", data.preview);
					setValue("draw", type === TYPE_BATTLE_DRAW);
					setEnd(data.is_end);

					// 1:1인데 이미지가 없는 경우
					if ((type === TYPE_BATTLE || type === TYPE_BATTLE_DRAW) && filteredImages.length <= 0) {
						setValue("type", TYPE_DEFAULT);
					} 
					if(type === TYPE_BATTLE_DRAW){
						setDraw(true)
					}
				},
				(error) => {
					if (error.response) {
						alert(error.response.data.message);
					} else {
						alert(error.message);
					}
					history.replace("/");
				},
			);
		} else {
			const endAt = momentJalaali().add(1, "day");
			setValue("date", endAt);
			setValue("hour", endAt.hour());
			setValue("minute", 0);
		}
	}, [history, id, setValue]);

	const hourOptions = useMemo(() => {
		return [...Array(24)].map((val, key) => {
			return {
				name: String(key) + t("시"),
				value: key,
			};
		});
	}, [t]);

	const minuteOptions = useMemo(() => {
		return [...Array(12)].map((val, key) => {
			return {
				name: String(key * 5) + t("분"),
				value: key * 5,
			};
		});
	}, [t]);

	/**
	 * 등록 & 수정
	 * @param data
	 */
	interface IItem {
		index: string;
	}
	const onSubmit = (data: Inputs) => {
		let answers = [];
		//답변정리
		for (var key in data.index) {
			answers.push({
				index: Number(data.index[key]),
				answer: String(data.answer[key]),
				image: data.image[key] ? String(data.image[key]) : null,
				id: Number(data.answerId[key]),
			});
		}
		//재정렬
		answers.sort((a, b): any => {
			return a.index - b.index;
		});
		delete data.index;
		delete data.answer;
		delete data.image;
		delete data.answerId;
		data.answers = answers;

		if (data.question.trim() === "") {
			alert(i18next.t("투표 제목을 입력해주세요."));
			return;
		}

		if (data.type === TYPE_BATTLE) {
			const answers = data.answers.slice(0, 2);
			const filteredAnswers = answers.filter((x) => x.answer.trim() !== "");
			if (filteredAnswers.length < 2) {
				alert(i18next.t("투표 항목을 입력해주세요."));
				return;
			}

			const filteredImages = answers.filter((x) => x.image);
			if (filteredImages.length === 1) {
				// 1:1형은 1개만 등록할 경우만 취소
				alert(i18next.t("이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다."));
				return;
			}
		}else if (data.type === TYPE_BATTLE_DRAW) {
			const answers = data.answers.slice(0, 3);
			const filteredAnswers = answers.filter((x) => x.answer.trim() !== "");
			if (filteredAnswers.length < 3) {
				alert(i18next.t("투표 항목을 입력해주세요."));
				return;
			}

			const filteredImages = answers.filter((x) => x.image);
			if (filteredImages.length < 3) {
				// 1:1형은 1개만 등록할 경우만 취소
				alert(i18next.t("이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다."));
				return;
			}
		} else {
			const filteredAnswers = data.answers.filter((x) => x.answer.trim() !== "");
			if (filteredAnswers.length < 2) {
				alert(i18next.t("투표 항목을 입력해주세요."));
				return;
			}
		}

		if (isMobile) {
			const endAt = inputStringToMoment(data.datetime);
			if (endAt.diff(momentJalaali()) < 0) {
				alert(i18next.t("현재시간 이후를 선택해주세요."));
				datetimeRef.current?.focus();
				return;
			}
			if (endAt.diff(momentJalaali(), "months") >= 3) {
				alert(i18next.t("투표 종료일을 3개월 이내로 선택해주세요."));
				datetimeRef.current?.focus();
				return;
			}
			data.end_at = endAt.format("YYYY-MM-DD HH:mm");
		} else {
			if (!isEnd) {
				data.date.set({ hour: data.hour, minute: data.minute });
				if (data.date.diff(momentJalaali()) < 0) {
					alert(i18next.t("현재시간 이후를 선택해주세요."));
					return;
				}

				if (data.date.diff(momentJalaali(), "months") >= 3) {
					alert(i18next.t("투표 종료일을 3개월 이내로 선택해주세요"));
					return;
				}
				data.end_at = data.date.format("YYYY-MM-DD HH:mm");
			}
		}

		data._method = isEditMode() ? "PUT" : "POST";

		Axios({
			method: "post",
			data,
			url: isEditMode() ? `//bjapi.afreecatv.com/api/vote/${id}` : `//bjapi.afreecatv.com/api/vote`,
			withCredentials: true,
		}).then(
			(response) => {
				if (isEditMode()) {
					alert(i18next.t("투표가 수정되었습니다."));
					votePostMessage({ action: "update", ...response.data });
				} else {
					alert(i18next.t("투표가 등록되었습니다."));
					votePostMessage({ action: "create", ...response.data });
				}
				window.close();
			},
			(error) => {
				if (error.response) {
					alert(error.response.data.message);
				} else {
					alert(error.message);
				}
			},
		);
	};

	/**
	 * 수정모드인지
	 */
	const isEditMode = useCallback(() => method === EDIT, [method]);

	/**
	 * 취소버튼
	 */
	const handleCancle = useCallback((e) => {
		window.close();
	}, []);

	const handleResize = useCallback((width, height) => {
		const thisPopupHeight = height + 69; //실제 크기
		if (window.screen.height - (window.screenTop + thisPopupHeight + 60) > 0) {
			window.resizeTo(478, thisPopupHeight);
		}
	}, []);

	/**
	 * INPUT datetime Format
	 */
	const getDatetimeLocal = useCallback((date: Moment) => {
		return date.format("YYYY-MM-DDTHH:mm:00");
	}, []);


	/**
	 * 무승부 항목 추가/삭제
	 */
	const handleDraw = useCallback(
		(event) => {			
			var isDraw = event.target.checked;
			if(isDraw){
				drawId.current = Math.random();
				/**
				 * 두번째 항목에 무승부 추가
				 */
				setAnswerIds((prev)=>{
					prev.splice(1, 0, drawId.current);
					return prev.slice();				
				});
				//AnswerIds 가 업데이트 되고 Job Queue를 통해 항목 세부내역을 추가함
				setTimeout(()=>{
					setValue(`answer[${drawId.current}]`, t("무승부"));
					setValue(`image[${drawId.current}]`,"//res.afreecatv.com/images/bj/vote_draw.jpg");					
				},1)
				
				setValue("type" , TYPE_BATTLE_DRAW, false)
			}else{				
				removeDrawAnswer();
				setValue("type" , TYPE_BATTLE)
			}
			setDraw(isDraw)
			
		},
		[removeDrawAnswer, setValue, t],
	)


	return (
		<FormContext {...formContextValues}>
			<form onSubmit={handleSubmit(onSubmit)}>
				<ReactResizeDetector onResize={handleResize}>
					<div>
						<article id="vote_wrap" className={classNames({ "vote-mobile": isMobile, edit: isEditMode() })}>
							{isMobile && (
								<header>
									<section className="basic-section">
										<div className="grid-start">
											<button type="button" className="btn-back" onClick={handleCancle}>
												<span>뒤로가기</span>
											</button>
										</div>
										<h2 className="title">
											<p><Trans>투표 등록</Trans></p>
										</h2>
										<div className="group-end">
											<button type="submit">
												<span><Trans>등록</Trans></span>
											</button>
										</div>
									</section>
								</header>
							)}
							{!isMobile && (
								<div className="vote-head">
									<h2><Trans>투표 등록</Trans></h2>
								</div>
							)}
							<div className="vote-body">
								<div className="vote-type">
									<div>
										<input
											type="radio"
											name="type"
											id="vote_type1"
											value={TYPE_DEFAULT}
											ref={register}
											disabled={isEditMode()}
										/>
										<label htmlFor="vote_type1"><Trans>기본형</Trans></label>
									</div>
									<div className={classNames( {hide:  isDraw})}>
										<input
											type="radio"
											name="type"
											id="vote_type2"
											value={TYPE_BATTLE}
											ref={register}
											disabled={isEditMode()}
										/>
										<label htmlFor="vote_type2"><Trans>1:1 투표</Trans></label>
									</div>
									<div className={classNames( {hide:  !isDraw})}>
										<input
											type="radio"
											name="type"
											id="vote_type3"
											value={TYPE_BATTLE_DRAW}
											ref={register}
											disabled={isEditMode()}
										/>
										<label htmlFor="vote_type3"><Trans>1:1 투표</Trans></label>
									</div>
								</div>

								<div className="vote-title">
									<div className="title">
										<TitleTextArea
											name="question"
											rows={1}
											maxLength={30}
											className="write-inp"
											placeholder={t("투표 제목을 입력해주세요.")}
										/>
									</div>
								</div>

								<div
									className={classNames("voting-list", {
										battle: type === TYPE_BATTLE || type === TYPE_BATTLE_DRAW,
										draw: type === TYPE_BATTLE_DRAW,
									})}
								>
									<Answers answerIds={answerIds} isEditMode={isEditMode()} type={type}  />
								</div>
								<div className="vote-setting">
									<dl className="date">
										<dt><Trans>투표 종료일</Trans></dt>
										<dd>
											<div className="date_mo">
												<input
													type="datetime-local"
													name="datetime"
													ref={(ref: HTMLInputElement) => {
														register(ref);
														datetimeRef.current = ref;
													}}
													id="datetime"
													disabled={isEnd}
													defaultValue={getDatetimeLocal(momentJalaali().add(1, "days"))}
												/>
												<label htmlFor="datetime" className="datetime">
													{inputStringToMoment(datetime).locale(lang).format("YYYY-MM-DD A HH:mm")}
												</label>
											</div>
											{isEnd ? (
												<div className="date_pc">
													<span>{inputStringToMoment(datetime).locale(lang).format("YYYY-MM-DD A HH:mm")}</span>
												</div>
											) : (
												<div className="date_pc">
													<div className="btn_calendar">
														<Controller
															as={
																<DatePicker
																	ref={dateRef}
																	inputFormat="YYYY-MM-DD"
																	min={momentJalaali().subtract(1, "days")}
																	max={momentJalaali().add(3, "months")}
																	timePicker={false}
																/>
															}
															name="date"
															control={control}
															onChange={([selected]) => selected}
														/>
													</div>
													<Controller as={<SelectBox options={hourOptions} />} name="hour" control={control} />
													<Controller
														as={<SelectBox options={minuteOptions} />}
														name="minute"
														control={control}
													/>
												</div>
											)}
										</dd>
									</dl>
									<dl className="setting">
										<dt><Trans>설정</Trans></dt>
										<dd>
											<div className="check">
												<input
													type="checkbox"
													name="preview"
													id="preview"
													defaultChecked={true}
													ref={register}
													disabled={isEditMode()}
												/>
												<label htmlFor="preview"><Trans>결과 미리보기 허용</Trans></label>
											</div>
											{type === TYPE_DEFAULT && (
												<div className="check ">
													<input
														type="checkbox"
														name="multiple"
														id="multiple"
														ref={register}
														disabled={isEditMode()}
													/>
													<label htmlFor="multiple"><Trans>복수 선택 허용</Trans></label>
												</div>
											)}
												{(type === TYPE_BATTLE|| type === TYPE_BATTLE_DRAW )&& <div className="check ">
													<input
														type="checkbox"
														name="draw"
														id="draw"
														ref={register}
														onChange={handleDraw}
														disabled={isEditMode()}
													/>
													<label htmlFor="draw"><Trans>무승부 항목 추가</Trans></label>
												</div>}
										</dd>
									</dl>
								</div>

								<div className="vote-btns">
									<button type="submit" className="btn-basic blue">
										<span><Trans>등록</Trans></span>
									</button>
									<button type="button" className="btn-basic" onClick={handleCancle}>
										<span><Trans>취소</Trans></span>
									</button>
								</div>
							</div>
						</article>
					</div>
				</ReactResizeDetector>
			</form>
		</FormContext>
	);
}
